<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
console.log(
  "%c极客实验室",
  "font-size: 60px;background: #EEE url(data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAAHklEQVQImWNkYGBgYGD4//8/A5wF5SBYyAr+//8PAPOCFO0Q2zq7AAAAAElFTkSuQmCC) repeat; text-shadow: 5px -5px black, 4px -4px white;  font-weight: bold;  -webkit-text-fill-color: transparent;  -webkit-background-clip: text;"
);
console.log(
  "%c%s",
  "color: blue; font-size: 16px;",
  "本程序由极客实验室开发\n\n作者邮箱admin@osuu.net \n\n你可以通过 http://shop.h234.cn 了解我们 "
);
console.log(
  "%c%s",
  "color: red; font-size: 16px;",
  "\n\n如您发现使用者用其程序进行诈骗、违法等活动\n\n请联系作者邮箱admin@osuu.net提供证据说明 \n\n我们将取消其授权并提交相关部门处理\n\n"
);
import { getSystem } from "@/api/index";
export default {
  name: "app",
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    
    // 判断设备
    if (document.body.clientWidth < 992) {
      this.$store.state.isMobile = true;
    } else {
      this.$store.state.isMobile = false;
    }
    this._getSystem();
  },
  methods: {
    // 获取基础设置
    _getSystem() {
      getSystem().then((res) => {
        this.$store.state.basic = res.data;
        this.$store.state.pageSize = res.data.pageSize;
      });
    },
  },
};
</script>

<style>
@import url("//at.alicdn.com/t/font_2556604_14k13npv5x5.css");
</style>